export type {
  CoreCompactProduct,
  CoreDimensions,
  CoreProduct,
  CoreProductAttributeWithValue,
  CoreProductAttributeWithValueInput,
  CoreProductBuyCostPrice,
  CoreProductBuyCostPriceInput,
  CoreProductCharacteristics,
  CoreProductOrderInput,
  CoreProductSellCostPriceInput,
  CoreProductTariffCode,
  CoreProductTariffCodeInput,
  CoreWeight,
  CoreWeightInput,
  CreateCoreProductInput,
  MoneyWithBigDecimalValue,
  MoneyWithBigDecimalValueInput,
  ProductsFilters,
  UpdateCoreProductInput
} from '@zen/graphql/types.generated';
export {
  CoreProductAttributeType,
  CoreProductOrderInputField,
  CoreProductStatus,
  LengthUnit,
  RegionCode,
  RiskLevel,
  UploadCoreProductsStrategy,
  WeightUnit
} from '@zen/graphql/types.generated';

export type ProductSettingsTab = 'product-categories' | 'product-attributes';

export const ProductsTrackingCategory = 'Products';

export const ProductCategoriesTrackingCategory = 'ProductCategories';

export const ProductAttributesTrackingCategory = 'ProductAttributes';

export enum ProductCategoriesTrackingAction {
  CATEGORY_CREATED = 'CategoryCreated',
  CATEGORY_DELETED = 'CategoryDeleted',
  CATEGORY_UPDATED = 'CategoryUpdated'
}

export enum ProductAttributesTrackingAction {
  ATTRIBUTE_CREATED = 'AttributeCreated',
  ATTRIBUTE_DELETED = 'AttributeDeleted',
  ATTRIBUTE_UPDATED = 'AttributeUpdated'
}

export enum ProductsTrackingAction {
  FORM_SUBMISSION = 'FormSubmission',
  PRODUCT_ARCHIVED = 'ProductArchived',
  PRODUCT_CLONED = 'ProductCloned',
  PRODUCT_UNARCHIVED = 'ProductUnarchived'
}
